/**
 * tri-model spells the German label of `pressureLow` "Niedriger druck" (src/model/telemetry.ts). Until that is
 * corrected there, every place of the alert editor that shows a measurement or alarm name passes it through here.
 * Remove together with the tri-model fix.
 */
const CORRECTED: Record<string, string> = {
    'Niedriger druck': 'Niedriger Druck',
};

export const correctedMeasurementLabel = (label: string): string => CORRECTED[label] ?? label;
